import { sendNativeMessage } from '@native-navigation/Utils/SendNativeMessage';
import { atom } from 'jotai';

const filterTrayOpenAtom = atom(false, (get, set, newValue) => {
  set(filterTrayOpenAtom, newValue);
  sendNativeMessage({ showBackButton: !newValue });
});

export { filterTrayOpenAtom };
